// extracted by mini-css-extract-plugin
export default {"byAcc__download":"styles_byAcc__download__R22tm"};